// Filter with select and BTN **Isotope**

const customSelect = document.querySelector(".searchebar__cliniques");

if (customSelect) {

  const filterValueSpe = document.querySelector(".select-css");
  const filterValueLieu = document.querySelector(".select-css.select-css2");
  // Arrow rotate on click
  const arrowSearch = document.querySelector(".searchArrow");
  const arrowSearch2 = document.querySelector(".searchArrow2");
  const arrowArea = document.querySelector(".optionsSearch1");
  const arrowArea2 = document.querySelector(".optionsSearch2");

  filterValueSpe.addEventListener("click", () => {
    arrowSearch.classList.add("searchArrowOn");
  });
  arrowArea.addEventListener("mouseleave", function () {
    arrowSearch.classList.remove("searchArrowOn");
  });

  filterValueLieu.addEventListener("click", () => {
    arrowSearch2.classList.add("searchArrowOn");
  });
  arrowArea2.addEventListener("mouseleave", function () {
    arrowSearch2.classList.remove("searchArrowOn");
  });
  // END Arrow

  const btnFilter = document.querySelector("button");

  btnFilter.addEventListener("click", () => {
    if (btnFilter.classList.value !== "all") {
      var filterValueEnd2 = filterValueLieu.value;
      var filterValueEnd = filterValueSpe.value;

      if (filterValueEnd === "") {
        filterValueEnd = "all";
      }
      if (filterValueEnd2 === "") {
        filterValueEnd2 = "all";
      }

      btnFilter.classList = "";

      if (filterValueEnd === "all") {
        btnFilter.classList.add(filterValueEnd2);

      } else if (filterValueEnd2 === "all") {
        btnFilter.classList.add(filterValueEnd);
      }

      const allCards = document.querySelectorAll(".filterCard");

      allCards.forEach((cards) => {
       

        if (btnFilter.classList.value != "all") {
          cards.classList.remove("onView");
          if (cards.classList.contains(btnFilter.classList.value)) {
            cards.classList.add("filterCard", "onView");
          }
        }
      });
    } else {
    }
    
  });
}
